import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const AlarmTimelineService = {
    getAlarmTimeline: async (id) => axios.get(API_URL + `/alarm_timeline/search/${id}`).then(({ data }) => data.data).catch((err) => { throw err }),

    getUserImage: (userId) => API_URL + `/user/getImage/${userId}`,
}

export default AlarmTimelineService;